import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpHeaders } from '@angular/common/http';
import { AppTokenHandler } from '../common/app-token-handler';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { Router } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";

import { ProgressService } from './progress.service';
@Injectable()

export class WinAuthInterceptor implements HttpInterceptor {
    constructor(private appToken: AppTokenHandler, private route: Router, private spinnerService: NgxSpinnerService,
         private progressService: ProgressService) { }
    loading = false;
    ShowMessage = true;
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        debugger
        //  req = req.clone({
        //     withCredentials: true
        // }); 


        // this.progressService.ChangeProgressStatus(true);
        // if (req.url === environment.tokenPath) {
        //     this.spinnerService.show();
        //     return next.handle(req).pipe(finalize(() => {
        //        // this.spinnerService.show();
        //        this.progressService.ChangeProgressStatus(false);
        //     }));
        // }
        // if (this.appToken.getSessionToken().length > 0) {
        //     const cloned_req = req.clone({

        //         headers: req.headers.set('access_token', this.appToken.getSessionToken())
        //     });
        //     return next.handle(cloned_req).pipe(finalize(() => {
        //        // this.spinnerService.hide();
        //        this.progressService.ChangeProgressStatus(false);
        //     }));
        // } else {
        //    // this.spinnerService.hide();
        //    this.progressService.ChangeProgressStatus(false);
        //     this.route.navigate(['/error/1']);
        // }

        if (req.url.includes(`${environment.tokenPath}`) || req.url.startsWith('https://login.microsoftonline.com')) {
            return next.handle(req);
          } else if (this.appToken.getSessionToken().length > 0) {
            const cloned_req = req.clone({
              headers: new HttpHeaders({
                'access_token': this.appToken.getSessionToken(),
                // 'Content-Type': 'application/json',
              }),
              withCredentials: true, // Ensure credentials are included
            });
       
            return next.handle(cloned_req);
          }
       
          return next.handle(req);
        }
    }

    // ******************************************Change Interceptor Code***********************//
    // intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    //     const authReq = req.clone({
    //         withCredentials: true,
    //         headers: req.headers.set('access_token', this.appToken.getSessionToken())
    //     });
    //     // tslint:disable-next-line:no-debugger
    //     if (!this.appToken.IsAuthenticated
    //         && !authReq.url.toLowerCase().includes('/api/Token'.toLowerCase())
    //     ) {
    //         // tslint:disable-next-line:no-debugger
    //         location.href = environment.sessionExpireUrl;
    //         return;
    //     }

    //     return next.handle(authReq).pipe(
    //         catchError((error: HttpErrorResponse) => {
    //             let errMsg = '';
    //             // tslint:disable-next-line:no-debugger
    //             if (this.appToken.IsAuthenticated) {
    //                 // tslint:disable-next-line:no-debugger
    //                 this.appToken.clearSessionToken();
    //                 if (error instanceof HttpErrorResponse && error.status === 417) {
    //                     errMsg = 'Your session expired. Request you to login again.';
    //                     alert(errMsg);
    //                     location.href = environment.sessionExpireUrl;
    //                     return;
    //                 }
    //                 // Client Side Error
    //                 if (error.error instanceof ErrorEvent) {
    //                     errMsg = 'Some error occured while processing your request';
    //                     // location.href = environment.unhandledErrorUrl;
    //                     this.route.navigate(['/error/2']);
    //                     return;
    //                 } else {  // Server Side Error
    //                     errMsg = 'Some error occured while processing your request';
    //                     // location.href = environment.unhandledErrorUrl;
    //                     this.route.navigate(['/error/2']);
    //                     return;
    //                 }
    //                 alert(errMsg);
    //                 // location.href = environment.unhandledErrorUrl;
    //                 this.route.navigate(['/error/2']);
    //                 return;
    //             } else {
    //                 if (this.ShowMessage) {
    //                     errMsg = 'Your session expired. Request you to login again.';
    //                     alert(errMsg);
    //                     location.href = environment.sessionExpireUrl;
    //                 }
    //                 this.ShowMessage = false;
    //                 return;
    //             }
    //             return throwError(errMsg);
    //         }), finalize(() => {
    //             // this.status.setHttpStatus(false);
    //         })
    //     );
    // }
    // *****************************************End *******************************************//
